export const APPEND_RELATIONS = 'APPEND_RELATIONS';
export const ADD_RELATIONS = 'ADD_RELATIONS';
export const UPDATE_USED_RELATION = 'UPDATE_USED_RELATION';

export function appendRelations(relations) {
    return { type: APPEND_RELATIONS, relations };
}
export function addRelations(relations) {
    return { type: ADD_RELATIONS, relations };
}
export function updateUsedRelation(relations) {
    return { type: UPDATE_USED_RELATION, relations };
}